import * as React from "react";
import Breadcrumb from "../components/breadcrumb";
import ResultsContent from "../components/shopping-list-stores/store-results";
import Layout from "../layout/layout";
import MobileFilter from "../components/shopping-list-stores/mobile-filter";
export default class StoreView extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let NavList = [
            { Text: 'Shopping List', Link: '/Products/ShoppingList' },
            { Text: 'Store Locator', Link: '' }
        ];
        const { stores, selected, updateSelected, mapOptions, showList, products, shoppingList, clusters, amenitesFilter } = this.props;
        return (React.createElement(Layout, null,
            React.createElement("div", { className: "main-search-result" },
                React.createElement(Breadcrumb, { NavList: NavList }),
                React.createElement("h5", { className: "product-warning" }, "Please contact the store to confirm availability. A retailer may sell out of any product at any time."),
                React.createElement("h1", null,
                    "MY SHOPPING LIST ",
                    React.createElement("span", null,
                        shoppingList.length,
                        " PRODUCTS")),
                React.createElement("div", { className: "show-more filter-mobile", onClick: this.props.updateMobileFilter },
                    "FILTER",
                    React.createElement("i", { className: "fa fa-plus" })),
                React.createElement(MobileFilter, { toggleMobile: this.props.mobileFilter, updateMobileToggle: this.props.updateMobileFilter, amenitesFilter: amenitesFilter, updateFilter: this.props.updateFilter, clearFilter: this.props.clearFilter }),
                React.createElement("div", { className: "mobile-filter-toggle" },
                    React.createElement("div", { className: !this.props.toggleMobile ? "active" : "", onClick: () => this.props.updateToggle(false) }, "List"),
                    React.createElement("div", { className: this.props.toggleMobile ? "active" : "", onClick: () => this.props.updateToggle(true) }, "Map")),
                React.createElement("div", { className: !this.props.toggleMobile ? "list-view" : "map-view" },
                    React.createElement(ResultsContent, { getLocation: this.props.getLocation, stores: stores, selected: selected, mapOptions: mapOptions, showList: showList, clusters: clusters, updateSelected: updateSelected, products: products, shoppingList: shoppingList, amenitesFilter: amenitesFilter, updateFilter: this.props.updateFilter, toggleList: this.props.toggleList, handleMapChange: this.props.handleMapChange, MarkerClick: this.props.MarkerClick, clusterMarkerClick: this.props.clusterMarkerClick, clearFilter: this.props.clearFilter, updateAddressText: this.props.updateAddressText })))));
    }
}
;
//# sourceMappingURL=shopping-list-stores.js.map